<template>
    <div class="page-root">
        <div class="menu" ref="menu" :class="{'menu-scroll': menuScroll}">
            <c-anchor
                :params="groupNameList || []"
                :duration="500"
                :top="-102"
                ref="anchor"
                :refresh="refreshAnchor"
            />
        </div>
        <div class="content">
            <div class="param-top" ref="param-top">
                <!-- 左上角选择框 -->
                <div class="choose-price">
                    <div class="choose-group">
                        <p>共{{formatInfo.length}}款车型</p>
                        <template v-if="!modelId">
                            <c-radio
                                v-model="hideSameParam"
                                :trueValue="true"
                                :falseVaue="false"
                                @change="handleHideSameParam"
                            >
                                <span class="same-param">隐藏相同参数</span>
                            </c-radio>
                            <c-radio
                                v-model="lightSameParam"
                                :trueValue="true"
                                :falseVaue="false"
                                @change="handleLightSameParam"
                            >
                                <span class="same-param">高亮不同参数</span>
                            </c-radio>
                        </template>
                    </div>
                    <div class="param-name price">经销商报价</div>
                </div>
            </div>
            <div class="param-content" ref="param-content">
                <div :class="{'param-ding': ding !== false}">
                    <div
                        v-for="(param, idx) in configList"
                        :key="param.itemName + '_' + idx"
                        class="param-cell"
                        :class="{
                            'param-cell-none': !(hideSameParam
                                ? hideSameParam && !param.diff
                                : true)
                        }"
                        :style="{
                            height: height[idx] + 'px',
                        }"
                    >
                        <div
                            v-if="param.id"
                            class="param-name item-name"
                            data-type="anchor"
                            :data-anchor="param.id"
                        >
                            {{param.itemName}}
                            <div
                                class="show-options">
                                <span>
                                    <span class="parameter-std parameter-left-4"></span>标配
                                </span>
                                <span>
                                    <span class="parameter-opt parameter-left-4"></span>选配
                                </span>
                                <span>
                                    <span class="parameter-line parameter-left-4"></span>无
                                </span>
                            </div>
                        </div>
                        <div
                            v-else
                            v-show="hideSameParam
                                ? hideSameParam && !param.diff
                                : true"
                            class="param-name sub-name"
                            :class="{
                                'light-same-param': !param.diff && lightSameParam
                            }"
                            :key="param.subName + idx"
                        >{{param.subName}}
                        </div>
                        <template v-if="dingData.length">
                            <c-cell
                                :item="dingData[idx]"
                                :config="param"
                                :light-same-param="lightSameParam"
                                :hide-same-param="hideSameParam"
                            />
                        </template>
                    </div>
                </div>
            </div>
            <div class="car-content">
                <div class="car-title" ref="car-title" :style="{
                    width: contentWidth,
                    paddingLeft: ding !== false ? '470px' : '240px'
                }">
                    <div
                        class="choose-price"
                        :class="{'ding-left': idx === ding}"
                        v-for="(item, idx) in formatInfo"
                        :key="item.id"
                        ref="ding-left"
                    >
                        <div class="choose-group">
                            <p
                                class="c-line-clamp2"
                                :title="joinSpace(item.seriesName, item.name)"
                                >{{joinSpace(item.seriesName, item.name)}}
                            </p>
                            <template v-if="!modelId">
                                <p @click="handleDing('cancel', idx)" v-if="ding === idx" class="ding ding-hover">
                                    <img width="20" height="20" src="@/common/images/contrast/dingding.svg">
                                    <span>已钉住</span>
                                    <span>取消钉住</span>
                                </p>
                                <p @click="handleDing('ding', idx)" v-else class="ding">
                                    <img width="20" height="20" src="@/common/images/contrast/ding.svg">
                                    <span>钉在最左侧</span>
                                </p>
                            </template>
                            <img v-if="formatConfigs.length > 1" @click="handleClose(idx)" class="close" src="@/common/images/parameter/close.svg">
                        </div>
                        <div class="param-name price-real">
                            <p>{{item.referencePrice}}</p>
                            <router-link
                                v-if="item.askPriceUrl"
                                :to="{
                                    name: 'ASK_PRICE',
                                    query: {
                                        modelId: item.id,
                                        fromPage: `${$route.path}@parameter_askPrice_click@${idx}`
                                    },
                                    params: {
                                        serid: item.seriesId
                                    }
                                }"
                                class="ask-price"
                                :data-key="'model_' + item.id"
                                :data-modelId="item.id"
                                :data-modelName="item.name"
                                :data-seriesId="item.seriesId"
                                :data-seriesName="item.seriesName"
                                :data-pos="idx"
                                target="_blank"
                                @click.native="navigateToLog(item, idx)"
                            >获取底价</router-link>
                        </div>
                    </div>
                </div>
                <div
                    class="car-all"
                    :style="{
                        width: contentWidth
                    }"
                >
                    <template v-for="(param, idx) in configList">
                        <div
                            class="car-row"
                            :key="idx"
                            v-show="hideSameParam
                                ? hideSameParam && !configList[idx].diff
                                : true"
                        >
                            <template v-for="(item, i) in formatConfigs">
                                <c-cell
                                    :item="item[idx]"
                                    :config="configList[idx]"
                                    :light-same-param="lightSameParam"
                                    :hide-same-param="hideSameParam"
                                    :margin-left="
                                        ding !== false && ding !== 0 ? i === 0 ? '230px' : i === ding + 1 ? '-230px' : '' : ''
                                    "
                                    :key="idx + '_' + i"
                                />
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="dataLoading" class="page-loading">
            <i class="el-icon-loading" />
            <p>加载中</p>
        </div>
    </div>
</template>

<script>
/**
 * @file
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {get} from 'lodash';
import {mapGetters} from 'vuex';
import {dataParse} from './format';
import {on, off} from 'js/Utils';
import {sendUbcLog} from 'js/ubclog';
import anchor from 'components/anchor';
import radio from './radio';
import mixinLog from '@/mixin/log.js';
import {sendLog, inSightObserver, inSightObserverDisconnect} from 'js/log';
import cell from './cell';

export default {
    mixins: [mixinLog],
    components: {
        'c-anchor': anchor,
        'c-radio': radio,
        'c-cell': cell
    },
    props: {
        serid: String,
        modelId: String
    },
    created() {
        this.init();
    },
    mounted() {
        on(window, 'scroll', this.handleFixed);
        on(window, 'resize', this.handleResize);
    },
    deactivated() {
        off(window, 'scroll', this.handleFixed);
        off(window, 'resize', this.handleResize);
    },
    beforeDestroy() {
        off(window, 'scroll', this.handleFixed);
        off(window, 'resize', this.handleResize);
        inSightObserverDisconnect();
    },
    computed: {
        ...mapGetters({
            location: 'location'
        }),
        contentWidth() {
            // 230: 数据宽度 240 最左一栏宽度
            return this.formatConfigs.length * 230 + 240 + 'px';
        }
    },
    watch: {
        '$store.state.location.cityName'() {
            this.init();
        }
    },
    data() {
        return {
            titleLeft: {},
            paramTop: {},
            carTitle: {},
            dingInfo: {},
            configs: [],
            display: [],
            groupNameList: [],
            configList: [],
            formatConfigs: [],
            formatInfo: [],
            needFixed: false,
            hideSameParam: false,
            lightSameParam: false,
            height: [],
            ding: false,
            hideInfo: [],
            closeFlag: false,
            menuScroll: false,
            dataLoading: true,
            dingData: [],
            refreshAnchor: +new Date()
        };
    },
    methods: {
        init() {
            // 兼容低版本路由
            if (this.$route.query.seriesId && !this.serid) {
                this.serid = this.$route.query.seriesId;
                this.modelId = this.$route.query.modelId;
            }
            this.$nextTick(() => {
                this.ding = false;
                if (this.modelId) {
                    this.getData(this.modelId);
                }
                else {
                    this.getAllModelInfo(this.serid);
                }
            });
        },
        getAllModelInfo(seriesId) {
            this.dataLoading = true;
            /* eslint-disable fecs-camelcase */
            request(URLS.GETMODELCONFIG2, {
                series_id: seriesId,
                city: this.location.cityName
            })
                .then(res => {
                    const {display, configs} = res.Result.modelList;
                    this.display = display;
                    this.dataParse(configs, display);
                })
                .catch(() => {
                    this.dataLoading = false;
                });
            /* eslint-enable fecs-camelcase */
        },
        getData(modelId) {
            this.dataLoading = true;
            /* eslint-disable fecs-camelcase */
            request(URLS.GETMODELCONFIG, {
                model_id: modelId,
                city: this.location.cityName
            })
                .then(res => {
                    const {display, configs} = res.Result.modelList;
                    this.display = display;
                    this.dataParse(configs, display);
                })
                .catch(() => {
                    this.dataLoading = false;
                });
            /* eslint-enable fecs-camelcase */
        },
        dataParse(data, display) {
            const {
                groupNameList,
                formatConfigs,
                configList,
                configs,
                formatInfo
            } = dataParse(data, display);
            // console.log(dataParse(data, display));

            this.groupNameList = groupNameList;
            this.configList = configList;
            this.formatConfigs = formatConfigs;
            this.formatInfo = formatInfo;
            this.configs = configs;
            this.dataLoading = false;
            this.$nextTick(() => {
                this.closeFlag = false;
                this.calcHeight();
                this.handleResize();

                inSightObserver(
                    '.ask-price',
                    'parameter_askprice_show',
                    null,
                    ['seriesName', 'seriesId', 'modelId', 'modelName', 'pos'],
                    {
                        log: true,
                        name: 'clue_form',
                        id: '11435',
                        data: {
                            seriesName: 'train_name',
                            seriesId: 'train_id',
                            modelId: 'type_id',
                            modelName: 'type_name'
                        },
                        options: {
                            ext: {
                                /* eslint-disable fecs-camelcase */
                                area: 'parameter_askPrice_click'
                                /* eslint-enable fecs-camelcase */
                            },
                            type: 'show',
                            page: '/view/parameter'
                        }
                    }
                );
            });
        },
        // 用于计算页面的定位位置
        handleFixed() {
            const scrollTop = document.documentElement.scrollTop
                    || document.body.scrollTop;
            const scrollLeft = document.documentElement.scrollLeft
                    || document.body.scrollLeft;
            // topbar 要一起动
            document.querySelector('header.el-header').style.top = -scrollTop + 'px';
            // 固定数：102，需要定位的位置距离窗口顶部的高度 195: 左边空白
            // 左边的参数title，需要和滚动条一起向上
            this.$refs['param-content'].style.top = -scrollTop + 102 + 'px';
            // 左上角选择框，如果已经到达顶部，则不需要继续滚动
            this.$refs['param-top'].style.top = (-scrollTop + 102 <= 0 ? 0 : -scrollTop + 102) + 'px';
            // 车型名称title，也是固定在顶部
            this.$refs['car-title'].style.top = (-scrollTop + 102 <= 0 ? 0 : -scrollTop + 102) + 'px';
            // 车型名称title，需要和滚动条一并左移
            this.$refs['car-title'].style.left = -scrollLeft + 195 + 'px';
        },
        handleDing(action, idx) {
            if (action === 'ding') {
                this.ding = idx;
                this.dingData = this.formatConfigs[idx];
            }
            else {
                this.dingData = [];
                this.ding = false;
            }
            this.handleFixed();
            sendLog('parameter_ding_click', {
                seriesId: this.formatInfo[idx].seriesId,
                modelId: this.formatInfo[idx].id,
                pos: this.idx,
                action
            });
        },
        handleHideSameParam() {
            this.height = [];
            this.$nextTick(() => {
                this.calcHeight();
            });
            sendLog('parameter_hideSameParam_click', {
                seriesId: this.serid
            });
        },
        handleLightSameParam() {
            sendLog('parameter_LightSameParam_click', {
                seriesId: this.serid
            });
        },
        handleClose(idx) {
            if (this.closeFlag) {
                return;
            }
            if (this.configs.length <= 1) {
                return;
            }
            sendLog('parameter_closeModel_click', {
                seriesId: this.serid,
                modelId: this.formatConfigs[idx].id,
                pos: idx
            });

            this.closeFlag = true;
            this.height = [];
            if (idx === this.ding) {
                this.ding = false;
                this.dingData = [];
            }
            else if (idx < this.ding) {
                this.ding = this.ding - 1;
            }

            this.dataParse(
                this.configs.filter((_, i) => i !== idx),
                this.display
            );
        },
        navigateToLog(item, pos) {
            /* eslint-disable fecs-camelcase */
            sendLog('parameter_askPrice_click', {
                seriesId: item.seriesId,
                modelId: item.id,
                pos,
                price_url: item.askPriceUrl
            });
            this.sendUbcLog('clue_form', {
                ext: {
                    city: this.location.cityName,
                    area: 'parameter_askPrice_click',
                    train_name: item.seriesName,
                    train_id: item.seriesId,
                    type_name: item.name,
                    type_id: item.id
                }
            });
            /* eslint-enable fecs-camelcase */
        },
        joinSpace(...args) {
            return [...args].join(' ');
        },
        calcHeight() {
            const height = [...document.querySelectorAll('.car-row')]
                .map(ele => ele.offsetHeight);
            this.height = height;
            this.$nextTick(() => {
                this.refreshAnchor = +new Date();
            });
        },
        handleResize() {
            this.calcMenu();
            this.calcNeedScrollY();
        },
        // 判断是否左侧菜单是否需要滚动
        calcMenu() {
            // 固定数：102，定位位置距离顶部的高度
            // 窗口高度
            const windowHeight = document.body.clientHeight
                || document.documentElement.clientHeight;
            // 菜单栏高度
            const menuHeight = document.querySelector('.anchor').offsetHeight;
            // 如果窗口高度 - 菜单栏高度 - 距离顶部的高度 小于0的话，则说明需要滚动
            if (windowHeight - menuHeight - 102 < 0) {
                this.menuScroll = true;
                this.$refs.menu.style.height = windowHeight - 102 + 'px';
            }
            else {
                this.menuScroll = false;
                this.$refs.menu.style.height = 'auto';
            }
        },
        // 判断是否需要横向滚动
        calcNeedScrollY() {
            // 获取窗口宽度
            const windowWidth = document.body.clientWidth
                || document.documentElement.clientWidth;
            // 如果总宽度小于窗口宽度的话，则不需要左右滚动
            // 195: 左边空白宽度
            if (windowWidth > 195 + this.contentWidth) {
                document.body.style.width = '100%';
                document.body.style.overflowX = 'hidden';
                let scrollY = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
                // 注意，由于之前用户可能已经滚动了，则需要滚动位置复位
                window.scrollTo(0, scrollY);
            }
            else {
                document.body.style.width = '';
                document.body.style.overflowX = '';
            }
        },
        sendUbcLog(name, options = {}) {
            /* eslint-disable fecs-camelcase */
            const ext = {
                client: 'pc',
                train_id: options.serid,
                train_name: options.seriesName,
                type_id: options.modelId,
                type_name: options.modelName,
                ...(options.ext || {})
            };
            sessionStorage.setItem('YOUJIA_SESSION_ASK_PRICE_BTN', JSON.stringify(ext));
            sendUbcLog('11435', 'event', {
                value: name,
                type: options.type || 'clk',
                page: '/view/parameter',
                ext
            });
            /* eslint-enable fecs-camelcase */
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.page-root {
    position: relative;
    margin: 102px auto 80px;
}
.menu {
    position: fixed;
    top: 102px;
    left: 0;
    width: 195px;
    padding-left: 79px;
    z-index: 10;
    &.menu-scroll {
        overflow-y: scroll;
    }
    /deep/ .anchor {
        font-size: 14px;
        background: #ffffff;
        > div {
            text-align: left;
            margin-bottom: 16px;
            cursor: pointer;
            &.anchorActive {
                color: @themeColor;
                font-weight: 500;
            }
        }
    }
}
.parameter-opt,
.parameter-std {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 1px solid #333333;
    border-radius: 50%;
}
.parameter-right {
    margin-left: 2px;
}
.parameter-left {
    margin-right: 2px;
}
.parameter-std {
    background: #333333;
}
.parameter-line {
    display: inline-block;
    width: 11px;
    margin-bottom: 6px;
    border-bottom: 1px solid #333333;
}

@paramsLeftWidth: 240px;
@paramsTopHeight: 214px;
@paddingLeft: 195px;
@paramsWidth: 230px;
.border(@top, @right, @bottom, @left) {
    border-width: @top @right @bottom @left;
    border-style: solid;
    border-color: #EEEEEE;
}
.content {
    position: relative;
    padding-left: @paddingLeft;
    font-size: 14px;
    .choose-price {
        width: 240px;
        height: @paramsTopHeight;
    }
    .choose-group {
        height: 122px;
    }
    
    .ding-left {
        position: fixed;
        left: 435px;
        z-index: 6;
    }
    
    .is-hover {
        border-bottom-color: @themeColor!important;
    }
    .param-param {
        padding: 12px 0;
        text-align: center;
    }
    .param-top {
        position: fixed;
        background: #FFFFFF;
        padding-left: @paddingLeft;
        left: 0;
        z-index: 9;
        .choose-price {
            .same-param {
                margin-left: 7px;
                color: #666666;
            }
        }
        .choose-group {
            padding: 27px 25px 25px;
            .border(1px, 1px, 1px, 1px);
            p {
                margin-bottom: 8px;
                color: #333333;
            }
        }
        &.needFixed {
            position: fixed;
            top: 0;
        }
        .param-name {
            padding: 12px 0 12px 20px;
            .border(0, 1px, 1px, 1px);
            &.price {
                font-size: 16px;
                height: 92px;
                line-height: 69px;
                color: #999999;
            }
        }
    }
    .param-content {
        position: fixed;
        padding-left: @paddingLeft;
        padding-top: @paramsTopHeight;
        left: 0;
        z-index: 7;
        font-size: 16px;
        line-height: 16px;
        background: #ffffff;
        > div {
            width: 240px;
            &.param-ding {
                width: 470px;
            }
        }
        .param-cell {
            display: flex;
            .border(0, 0, 1px, 0);
            &-none {
                border: none;
            }
        }
        .item-name {
            width: 240px;
            box-sizing: content-box;
            position: relative;
            height: 42px;
            line-height: 42px;
            padding-left: 20px;
            .border(0, 0, 0, 1px);
            background: #F8F8F8;
            color: #333333;
        }
        .sub-name {
            width: 240px;
            display: flex;
            min-height: 47px;
            align-items: center;
            padding: 12px 0 12px 20px;
            .border(0, 1px, 0px, 1px);
            background: #ffffff;
            color: #999999;
        }
        .show-options {
            position: absolute;
            width: 220px;
            left: 240px;
            top: 0;
            > span {
                margin-right: 12px;
            }
            .parameter-left-4 {
                margin-right: 4px;
            }
        }
    }
    .car-content {
        // padding-left: @paramsLeftWidth;
        font-size: 16px;
        line-height: 16px;
        .choose-price {
            width: 230px;
        }
        .choose-group {
            padding: 31px 20px 0;
            font-size: 16px;
            line-height: 16px;
            color: #333333;
        }
        .ding {
            position: absolute;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: @themeColor;
            bottom: 13px;
            left: 0;
            cursor: pointer;
            &.ding-hover {
                span:nth-child(2) {
                    display: inline;
                }
                span:nth-child(3) {
                    display: none;
                }
                &:hover {
                    span:nth-child(2) {
                        display: none;
                    }
                    span:nth-child(3) {
                        display: inline;
                    }
                }
            }
        }
        .item-title {
            left: auto;
        }
        .param-items {
            width: 230px;
        }
        .car-title {
            position: fixed;
            display: flex;
            background: #FFFFFF;
            z-index: 7;
            .choose-price {
                background: #FFFFFF;
            }
            .choose-group {
                position: relative;
                .border(1px, 1px, 1px, 0);
                p {
                    line-height: 20px;
                }
            }
            .price-real {
                height: 92px;
                padding-top: 18px;
                text-align: center;
                .border(0, 1px, 1px, 0);
                p {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    margin-bottom: 4px;
                    color: #FF6F61;
                }
                a {
                    display: block;
                    width: 100px;
                    height: 30px;
                    margin: 4px auto;
                    line-height: 30px;
                    font-size: 14px;
                    border-radius: 3px;
                    color: #FFFFFF;
                    background: @themeColor;
                }
            }
            .close {
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }
        }
        .car-all {
            overflow: hidden;
            padding-top: @paramsTopHeight;
            .car-row {
                position: relative;
                display: flex;
                padding-left: @paramsLeftWidth;
                .border(0, 0, 1px, 0);
            }
        }
    }
}

.page-loading {
    position: fixed;
    width: 100px;
    padding-top: 20px;
    height: 100px;
    top: 50%;
    left: 50%;
    margin: -50px 0 0 -50px;
    border-radius: 8px;
    z-index: 999;
    font-size: 16px;
    color: #999999;
    text-align: center;
    i {
        margin-bottom: 8px;
    }
}
</style>
